import Link from "next/link";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import ToggleButton from "../toggle/button";

import price_changer from "../../data/price_change.json";
import pidPrice from "../../data/pid.json";
import useInView from "react-cool-inview";
import Section from "../pr/section";
import { plans } from "../../data/weight_loss/cart.json";
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
const MenHealthCart = (props) => {
  const [price, setPrice] = useState(null);
  const [ready, setReady] = useState(true);
  const [program, setProgram] = useState("Start Program");
  const iconCheck = <svg fill="#368fff" xmlns="http://www.w3.org/2000/svg" height="1.4em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])
  useEffect(() => {
    if (props.pid) {
      const findPriceChanger = price_changer.find((x) => x.pid == props.pid);
      const findPidChanger = pidPrice.find((x) => x.pid == props.pid);
      if (findPriceChanger && findPidChanger) {

        setPrice(findPriceChanger.price);
        Cookies.set("pid_main", findPriceChanger.price);
        if (findPidChanger.price == "") {

          Cookies.remove("sub_pid");
        } else {
          Cookies.set("sub_pid", findPidChanger.price);
        }
      } else {

        Cookies.remove("sub_pid");
        Cookies.remove("pid_main");
      }
    } else {

      Cookies.remove("sub_pid");
      Cookies.remove("pid_main");
    }
  }, []);
  const { observe, unobserve, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });
  const router = useRouter();
  Cookies.remove("testImg");
  Cookies.remove("cartName");
  Cookies.remove("cartPrice");
  Cookies.remove("cartType");
  return (
    <div className="section-gap" id="view-tests" ref={observe}>
      {" "}
      {inView && (
        <div className="container">
          <div className="text-center">
            <h2 className="text-cart text-center mt-5 mb-3 visit-heading">
              Book your comprehensive lab test and follow-up now
            </h2>
            <span className="text-center new-color text-mute mt-5">Choose between using your insurance or our affordable self pay rates at checkout</span>
          </div>
          <ToggleButton
            myCart={props.myCart}
            setPrice={props.setPrice}
            insurance={props.insurance}
            setInsuranceVal={props.setInsuranceVal}
          />
          <div className="row justify-content-center">
            <div className="col-md-4 ">
              <div className="cart-section most-popular">
                <label className="card-label" style={{ zIndex: 100 }}>
                  Most Popular
                </label>
                <div className="card cart-view-card">
                  <div className="card-body-1">
                    <div className="row">
                      <div className="panel-price">
                        <h2 className="cart-heading-weightloss">
                          {" "}
                          {props.data.plan2.heading}
                        </h2>
                        {/* <h3 className="cart-heading">
                            <span></span> ${props.data.plan2.price}
                          </h3> */}
                        <h2 className="cart-heading text-decoration-line-through">
                          ${props.data.plan2.slashed + price}
                        </h2>
                      </div>
                    </div>
                    <p className="cart-text text-light-blue">
                      {props.data.plan2.subHeading}
                    </p>
                    <h4 className="cart-h4 text-light-blue">Details:</h4>
                    <div className="card-points">
                      <div className="row">
                        {props.data.plan2.checked.map((element, key) => (
                          <div className="col-md-12" key={key}>
                            <div className="mt-2">
                              <span className="cart-list text-light-blue">
                              {iconCheck}
                                &nbsp; {element.title}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="cart-btn-section1">
                      <div className="card-btn-main">
                        <button
                          className="btn btn-lg-secondary weight-loss-check-btn"
                          onClick={(e) =>
                            props.goToCheckout({
                              img: "v1678202051/NextMed/Male_Hormone_v9ymc5.png",
                              name: "Male Hormone Complete",
                              type: "menhealth",
                              price:
                                price
                                  ? props.data.plan2.price + price
                                  : props.data.plan2.price,
                              labfee: props.data.plan2.labfee,
                            })
                          }
                        >
                          Book Now - $
                          {price
                            ? props.data.plan2.price + price
                            : props.data.plan2.price}{" "}
                          &nbsp;
                          <span className="panel-discount">
                            ${props.data.plan2.slashed + price}
                          </span>
                        </button>
                      </div>
                      <div className="required-field2">
                        <span className="panel-text text-center">  Save ${props.data.plan2.labfee} with insurance</span>
                        {/* <div className="input-group-diseases treatement_icon">
                          <img src="/why_section/8.gif" />
                          Treatment included
                          <span className="disease-text"></span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
            <div className="cart-section most-popular">
                <label className="card-label-doc" style={{ zIndex: 100 }}>
                  Doctor Recommend
                </label>
                <div className="card cart-view-card">
                  {/* <label className="card-label">Most Popular</label> */}
                  <div className="card-body-1">
                    <div className="row">
                      <div className="panel-price">
                        <h2 className="cart-heading-weightloss">
                          {" "}
                          {props.data.plan1.heading}
                        </h2>
                        {/* <h3 className="cart-heading">
                            <span></span> ${props.data.plan1.price}
                          </h3> */}
                        <h2 className="cart-heading text-decoration-line-through">
                          ${props.data.plan1.slashed + price}
                        </h2>
                      </div>
                    </div>
                    <p className="cart-text text-light-blue">
                      {props.data.plan1.subHeading}
                    </p>
                    <h4 className="cart-h4 text-light-blue">Details:</h4>
                    <div className="card-points">
                      <div className="row">
                        {props.data.plan1.checked.map((element, key) => (
                          <div className="col-md-12 col-12" key={key}>
                            <div className="mt-2">
                              <span className="cart-list text-light-blue">
                               {iconCheck}
                                &nbsp; {element.title}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="cart-btn-section2">
                      <div className="card-btn-main">
                        <button
                          className="btn btn-lg-secondary weight-loss-check-btn"
                          onClick={(e) =>
                            props.goToCheckout({
                              img: "v1678202051/NextMed/Male_Hormone_v9ymc5.png",
                              name: "Male Hormone Standard",
                              type: "menhealth",
                              price: price
                                ? props.data.plan1.price + price
                                : props.data.plan1.price,
                              labfee: props.data.plan1.labfee,
                            })
                          }
                        >
                          Book Now - $
                          {price
                            ? props.data.plan1.price + price
                            : props.data.plan1.price}{" "}
                          &nbsp;
                          <span className="panel-discount">
                            ${props.data.plan1.slashed + price}
                          </span>
                        </button>
                      </div>
                      <div className="required-field2">
                        <span className="panel-text text-center">  Save ${props.data.plan1.labfee} with insurance</span>
                        {/* <div className="input-group-diseases ">
                          <img src="/why_section/3.gif" />
                          Fastest results
                          <span className="disease-text"></span>
                        </div> */}
                        {/* <div className="input-group-diseases treatement_icon">
                          <img src="/why_section/8.gif" />
                          Treatment included
                          <span className="disease-text"></span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>{" "}
          {/* <div className="section-title">
            <span>
              Unlike other companies, if you have insurance, Next Medical will
              provide you with documentation and help you submit an
              out-of-network claim for our services. This means most of our
              insured customers receive 70% reimbursement from their insurance
              carriers for any costs associated with testing or treatment.Listed
              prices are with the use of health insurance at the lab. Crossed
              out prices are fully out-of-pocket.
            </span>
          </div> */}
          {/* {props.dki != null && <Section />} */}
        </div>
      )}{" "}
    </div>
  );
};
export default MenHealthCart;